export default "__VITE_PUBLIC_ASSET__aa24b2e2__"